//import {useState} from 'react';
import { Api,CommonEndApi } from "../api/Api";
import * as EnvConstants from "../Constants/EnvConstants";
import {useErrorWebhook} from "./useErrorWebhook";
import {getProjectCode} from "../Utility/Domain_brand_postcode_configurations";
import { getBuyerName } from "../Components/Includes/Layouts/Common/BuyerBasedOnDomain";

const {brand,b_id} = getBuyerName();
const domain = window.location.hostname;
let envProjectCode = 'LUFP103';

const localVendor = localStorage.getItem('vendor');
if(localVendor && localVendor.trim() !== ''){
  if(localVendor.trim() === 'checkboard'){
    envProjectCode = 'LUFP103-CB';
  }else{
    envProjectCode = 'LUFP103';
  }
} else{
  envProjectCode = getProjectCode(domain,brand);
}

export const usePostCodeAddress = () => {

  const { ErrorWebhookTrigger } = useErrorWebhook();
  const getPostcodeAddress = async (postcode,uuid) => {
    const response = await CommonEndApi.get(
      "api/get-addr-list?ProjectCode=" + envProjectCode + '&Environment=' + EnvConstants.AppEnv + '&postcode='+postcode +'&uuid='+uuid,
      {}
    ).catch(function (error) {
      const erroMessage = {
        serviceName : 'GET POSTCODE ADDRESS LIST',
        errorReason:error.message,
        errorCode:error.code
      }
      ErrorWebhookTrigger(erroMessage);
    });;
    return response;
  };
  const getSplitPostcodeAddress = async (AddressID, postcode ,uuid) => {
    const response = await CommonEndApi.get(
      "api/get-addr-details?ProjectCode=" + envProjectCode + '&Environment=' + EnvConstants.AppEnv + '&addressId='+AddressID +"&uuid="+uuid,
      {}
    ).catch(function (error) {
      const erroMessage = {
        serviceName : 'GET POSTCODE ADDRESS DETAILS',
        errorReason:error.message,
        errorCode:error.code
      }
      ErrorWebhookTrigger(erroMessage);
    });;
    return response;
  };
  return { getPostcodeAddress, getSplitPostcodeAddress };
};
